<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <OnClickOutside @trigger="$emit('modal-cancel')">
        <div class="modal-container" ref="target">
          <div class="modal-header">
            <slot name="header"> default header</slot>
          </div>
          <div class="modal-body">
            <slot name="content"> default content</slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <div>
                <button @click.stop="$emit('modal-close')">Submit</button>
              </div>
            </slot>
          </div>
        </div>
      </OnClickOutside>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { OnClickOutside } from '@vueuse/components';

@Options({
  components: { OnClickOutside },
  emits: ['modal-close', 'modal-cancel'],
  props: {
    isOpen: {
      type: Boolean,
    },
  },
})
export default class Modal extends Vue {
}
</script>
<style lang="scss">
.modal-mask {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-container {
  width: 300px;
  margin: 150px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  .modal-header{
    h2 {
      margin: 0;
    }
  }

}

</style>
